export default __webpack_public_path__ + "static/media/dimitri-de-donder.76327e0b.jpg";